/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * MessageDispatch represents an attempt of sending a courier message It contains the status of the attempt (failed or successful) and the error if any occured
 */
export interface MessageDispatch { 
    /**
     * CreatedAt is a helper struct field for gobuffalo.pop.
     */
    created_at: string;
    error?: object;
    /**
     * The ID of this message dispatch
     */
    id: string;
    /**
     * The ID of the message being dispatched
     */
    message_id: string;
    /**
     * The status of this dispatch Either \"failed\" or \"success\" failed CourierMessageDispatchStatusFailed success CourierMessageDispatchStatusSuccess
     */
    status: MessageDispatch.StatusEnum;
    /**
     * UpdatedAt is a helper struct field for gobuffalo.pop.
     */
    updated_at: string;
}
export namespace MessageDispatch {
    export type StatusEnum = 'failed' | 'success';
    export const StatusEnum = {
        Failed: 'failed' as StatusEnum,
        Success: 'success' as StatusEnum
    };
}


